import { render } from "./manageRole.vue?vue&type=template&id=f84a824a"
import script from "./manageRole.vue?vue&type=script&lang=js"
export * from "./manageRole.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__